var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn rounded-circle border-0 d-flex justify-content-center align-items-center",attrs:{"aria-label":_vm.$t('main.ui.video.playVideo')},on:{"click":() => _vm.$emit('click')}},[_vm._t("default",function(){return [_c('div',{staticClass:"default-play"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }